webpackJsonp([30941037784260],{

/***/ "./node_modules/json-loader/index.js!./.cache/json/shop-merino-beanie.json":
/***/ (function(module, exports) {

	module.exports = {
		"pathContext": {
			"path": "/shop/merino-beanie/"
		}
	};

/***/ })

});


// WEBPACK FOOTER //
// path---shop-merino-beanie-5142a2bdf960c6e9ff53.js